import {Component, inject} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";
import {ContainerComponent} from "@coreui/angular";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {DrawWinnerPageComponent} from "./game-admin-draw-winner/draw-winner-page.component";
import {GameService} from "../../services/game.service";
import {GameInstanceService} from "../../services/game-instance.service";
import {ActiveUserService} from "../../services/active-user.service";
import {ErrorHandlingService} from "../../services/error-handling.service";

/**
 * Single scope-aware draw-winner entry point, replacing the former cross-game shell + direct
 * game-admin route. This pair is asymmetric: the shared workhorse is DrawWinnerPageComponent
 * (<app-draw-winner>, self-contained with its own layout).
 *   - game scope (route data isCrossGame:false): the active game is already selected
 *     (GameSelectedGuard), so render the workhorse directly — exactly as the old direct route did.
 *   - global scope (isCrossGame:true): show the manually-drawn game picker; on choose, fetch the
 *     game's active instance, set it active, then render the workhorse — as the old cross-game shell.
 */
@Component({
  selector: 'app-draw-winner-landing',
  standalone: true,
  imports: [
    ChooseYourGameComponent,
    ContainerComponent,
    DrawWinnerPageComponent
  ],
  templateUrl: './draw-winner-landing.component.html',
})
export class DrawWinnerLandingComponent {
  private route = inject(ActivatedRoute);
  private gameService: GameService = inject(GameService);
  private gameInstanceService: GameInstanceService = inject(GameInstanceService);
  private activeUserService: ActiveUserService = inject(ActiveUserService);
  private errorHandlingService: ErrorHandlingService = inject(ErrorHandlingService);

  protected isCrossGame = this.route.snapshot.data['isCrossGame'] === true;
  protected chosenGame: IGameQueryResult | null = null;

  onGameChange(chosenGame: IGameQueryResult) {
    this.gameInstanceService.activeGameInstanceByGame(chosenGame.Id, this.activeUserService.activeUser().Id).subscribe({
      next: () => {
        this.gameService.updateActiveGame(chosenGame);
        this.chosenGame = chosenGame;
      },
      error: () => {
        this.errorHandlingService.displayPageLevelErrorMessage("Failed to get the active game instance for the chosen game");
      }
    });
  }
}
